import IntroFade from "./Pages/IntroFade";
import { useEffect, useState } from "react";
import Navbar from "./Components/Navbar";
import Slider from "./Pages/Slider";
import TextBrand from "./Pages/TextBrand";
import SideMenu from "./Components/SideMenu";
import Feedback from "./Pages/Feedback";
// import ScrollIndicator from "./Components/ScrollIndicator";
import Footer from "./Components/Footer";
import AskMyAI from "./Components/AskMyAI";

function App() {
  const [animate, setAnimate] = useState(false);
  const [fontsReady, setFontsReady] = useState(false);

  // Hold the site at the background color until the two above-the-fold fonts are loaded (or 1s passes)
  useEffect(() => {
    let cancelled = false;
    const reveal = () => {
      if (!cancelled) setFontsReady(true);
    };
    const fontsLoaded = Promise.all([
      document.fonts.load('600 40px "Big Shoulders Inline Display"'),
      document.fonts.load('500 16px Poppins'),
    ]);
    Promise.race([
      fontsLoaded,
      new Promise((resolve) => setTimeout(resolve, 1000)),
    ]).then(reveal);
    return () => {
      cancelled = true;
    };
  }, []);

  // useEffect commented out to disable intro animation during inspection
  /*
  useEffect(() => {
    if (window.sessionStorage.getItem("initialLoad") === null) {
      setAnimate(true);
      setTimeout(() => {
        window.sessionStorage.setItem("initialLoad", 1);
        setAnimate(false);
      }, 9500);
    }
  }, [setAnimate]);
  */

  return (
    <>
      {animate ? (
        <IntroFade setAnimate={setAnimate} />
      ) : (
        <div
          style={{
            opacity: fontsReady ? 1 : 0,
            transition: "opacity 0.25s ease",
          }}
        >
          <Navbar />
          <SideMenu/>
          <div id="home">
            <TextBrand />
          </div>
          <div id="projects">
            <Slider />
          </div>
          <div id="reviews">
            <Feedback />
          </div>
          <Footer />
          <AskMyAI />
          {/* <ScrollIndicator /> */}
        </div>
      )}
    </>
  );
}

export default App;
